// extracted by mini-css-extract-plugin
export default {"comment":"CommentsBlock_comment__JH+il","my_comment":"CommentsBlock_my_comment__2rOkx"};